export default __webpack_public_path__ + "static/media/001.5497b6b4.jpg";